<template>
    <div class="modal-mask" v-on:scroll="scrollMove($el)">
        <div class="modal-wrapper">
            <transition name="fade" mode="out-in">
                <ViewNotice v-if="isNotice" :noticeData="campaignData" @closeNotice="closeNotice" ></ViewNotice>
            </transition>
            
            <div class="modal-container d-flex flex-column">
                <router-view></router-view>
                <div ref="degreeHeader">
                    <ViewHeader
                    :basicData="basicData"
                    ></ViewHeader>
                </div>
                
                <div class="flex-grow-1">
                    <ViewSubTab
                        :setTabFixed="setTabFixed"
                        @setSubTab="setSubTab"
                    ></ViewSubTab>

                    <div v-if="basicData" :class="setTabFixed && isAction ? 'mgt-50 mgb-60' : ''">
                        <component :is="tabType"
                            :teacher="basicData.teacher"
                        ></component>
                    </div>

                    
                </div>
                <ViewFooter
                    :basicData="basicData"
                    :setTabFixed="setTabFixed"
                ></ViewFooter>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 전체 차수 상세 메인 컴포넌트(Total degree view main Component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import degreeApi from '@/api/degreeApi.js'
import campaignApi from '@/api/campaignApi.js'
import ViewHeader from './view/Header.vue'
import ViewFooter from './view/Footer.vue'
import ViewSubTab from './view/SubTab.vue'
import ViewCourse from './view/Course.vue'
import ViewLesson from './view/Lesson.vue'
import ViewReward from './view/Reward.vue'
import ViewCertification from './view/Certification.vue'
import ViewNotice from './view/Notice.vue'

export default {
    data() {
        return {
            tabType: 'ViewCourse',
            basicData: null,
            setTabFixed: false,
            campaignData: null,
            isNotice: false
        }
    },

    components: {
        ViewHeader, ViewFooter, ViewSubTab, ViewCourse, ViewLesson, ViewReward, ViewCertification,
        ViewNotice
    },

    mixins: [topAppBarMixin],

    mounted() {
        this.fetchData()
    },

    updated() {
        const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
            let button = new MDCRipple.attachTo(el)
            return button
        })
    },

    computed: {
       isAction() {
           return this.basicData.actions[0].enable
       }
    },

    methods: {
        setSubTab(type) {
            this.tabType = type
        },

        // 기본 데이터 호출(call api basic data)
        fetchData() {
            let responseData = null
            let params = this.setParams()
            this.$showLoading()

            // degree basic data
            degreeApi.guestLearnOnlineViewBasic(params).then((response) => {
                this.basicData = response.data.data
                console.log('view this.basicData', this.basicData)
                this.$hideLoading()
            }).catch((err) => {
                responseData = err.response.data.meta
                this.$error({content: responseData.errMsg}).then(() => {})
            })

            // degree notice data
            campaignApi.campaign({locationType: 'IN_DEGREE', locationValue: this.$route.params.degreeId }).then((response) => {
                console.log('campaign response.data.data', response.data.data);
                this.campaignData = response.data.data
                if (this.campaignData) {
                    
                    this.isNotice = true
                }
            }).catch((err) => {})

        },
        
        // set parameter
        setParams() {
            const params = {
                degreeId: this.$route.params.degreeId
            }
            return params
        },

        // 스크롤 이동에 따른 상하단 고정(Fixed top and bottom according to scroll movement)
        scrollMove(el) {
            if (parseInt(el.scrollTop) >= parseInt(this.$refs.degreeHeader.offsetHeight)) {
                this.setTabFixed = true
            }else {
                this.setTabFixed = false
            }
        },

        // 공지사항 닫기(close notice)
        closeNotice() {
            this.isNotice = false
        }
    }
}
</script>
